define(['exports', 'react', './CloseButtonDialog', '../utils/uiHelper'], function (exports, _react, _CloseButtonDialog, _uiHelper) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _CloseButtonDialog2 = _interopRequireDefault(_CloseButtonDialog);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var AppErrorInfoDialog = function (_React$Component) {
    _inherits(AppErrorInfoDialog, _React$Component);

    function AppErrorInfoDialog(props) {
      _classCallCheck(this, AppErrorInfoDialog);

      var _this = _possibleConstructorReturn(this, (AppErrorInfoDialog.__proto__ || Object.getPrototypeOf(AppErrorInfoDialog)).call(this, props));

      _this.state = { open: false, errorInfo: null };
      return _this;
    }

    _createClass(AppErrorInfoDialog, [{
      key: 'handleOpen',
      value: function handleOpen(errorInfo) {
        (0, _uiHelper.disablePageScroll)();
        this.setState({ open: true, errorInfo: errorInfo });
      }
    }, {
      key: 'handleClose',
      value: function handleClose() {
        if (!this.state.open) {
          return;
        }

        (0, _uiHelper.enablePageScroll)();
        this.props.showAppError(null);
        this.setState({ open: false, errorInfo: null });
      }
    }, {
      key: 'renderErrorMessage',
      value: function renderErrorMessage() {
        return _react2.default.createElement(
          'div',
          { className: 'h5 red text-wrap pl1' },
          this.state.errorInfo.message
        );
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return _react2.default.createElement(
          'div',
          { className: 'col-12' },
          _react2.default.createElement(
            _CloseButtonDialog2.default,
            {
              open: this.state.open,
              modal: false,
              title: _react2.default.createElement(
                'div',
                { className: 'h4' },
                this.state.errorInfo && this.state.errorInfo.title
              ),
              autoScrollBodyContent: true,
              contentStyle: { 'margin': ' auto', 'maxWidth': '100%', 'width': '50%' },
              onRequestClose: function onRequestClose() {
                return _this2.handleClose();
              } },
            this.state.errorInfo && this.renderErrorMessage()
          )
        );
      }
    }]);

    return AppErrorInfoDialog;
  }(_react2.default.Component);

  exports.default = AppErrorInfoDialog;


  AppErrorInfoDialog.propTypes = {};
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/common/AppErrorInfoDialog.js
// module id = 1145
// module chunks = 0